import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDataAction } from "../../config/redux/action";
import { Menu } from "semantic-ui-react";

export const MenuTopReport = (props) => {
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.main);
  const user = useSelector((state) => state.main.dataUser);
  const dataReport = useSelector((state) => state.reportReducer.dataReport);

  const [ActiveItem, setActiveItem] = useState("Laba/Rugi");
  const disabledInput = user.role < 4;

  const handleChange = (e, { name }) => {
    setActiveItem(name);
  };

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    let pathAPI = "laba-rugi";
    switch (ActiveItem) {
      case "Neraca":
        pathAPI = "neraca";
        break;
      case "Arus Kas":
        pathAPI = "arus-kas";
        break;
      case "LPE":
        pathAPI = "laporan-perubahan-ekuitas";
        break;
      case "Dokumen Laporan":
        pathAPI = "document";
        break;
      default:
        pathAPI = "laba-rugi";
    }

    dispatch({
      type: "GET_ISLOADING_REPORT",
      data: true,
    });

    dispatch({
      type: "GET_MENU_REPORT",
      data: ActiveItem,
      pathAPI: pathAPI,
    });

    if (disabledInput) {
      if (filter.perusahaanFilter) {
        dispatch(
          getDataAction({
            path: `${pathAPI}?search=year:${filter.yearFilter || year
              },and,month:${filter.monFilter},and,perusahaan_id:${filter.perusahaanFilter
              }`,
            type: "GET_DATA_REPORT",
          })
        );
      }
    } else {
      dispatch(
        getDataAction({
          path: `${pathAPI}?search=year:${filter.yearFilter || year
            },and,month:${filter.monFilter}`,
          type: "GET_DATA_REPORT",
        })
      );
    }
  }, [
    ActiveItem,
    filter.yearFilter,
    filter.monFilter,
    filter.perusahaanFilter,
  ]);

  useEffect(() => {
    dispatch({
      type: "GET_ISLOADING_REPORT",
      data: dataReport ? false : true,
    });
  }, [dataReport]);

  return (
    <>
      <Menu pointing secondary className="menu--top">
        <Menu.Item
          name="Laba/Rugi"
          color="blue"
          active={ActiveItem === "Laba/Rugi"}
          onClick={handleChange}
        />
        <Menu.Item
          name="Neraca"
          color="blue"
          active={ActiveItem === "Neraca"}
          onClick={handleChange}
        />
        <Menu.Item
          name="LPE"
          color="blue"
          active={ActiveItem === "LPE"}
          onClick={handleChange}
        />
        <Menu.Item
          name="Arus Kas"
          color="blue"
          active={ActiveItem === "Arus Kas"}
          onClick={handleChange}
        />
        <Menu.Item
          name="Dokumen Laporan"
          color="blue"
          active={ActiveItem === "Dokumen Laporan"}
          onClick={handleChange}
        />
      </Menu>
      {props.children}
    </>
  );
};
